import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../mock/mock';

const ServicesGrid = ({ limit }) => {
  const list = limit ? services.slice(0, limit) : services;
  return (
    <section className="sect bg-[var(--rs-cream)] relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-green)] mb-3">Our services</div>
            <h2 className="h-display text-4xl md:text-5xl text-[var(--rs-ink)]">
              A single trusted partner for every property service you outsource.
            </h2>
          </div>
          <Link to="/services" className="btn-ghost self-start lg:self-end">All services <ArrowUpRight className="w-4 h-4" /></Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {list.map((s) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Link key={s.id} to={`/services/${s.id}`} data-testid={`services-grid-card-${s.id}`} className="rs-card lift p-5 group flex flex-col">
                <div className="relative h-40 -mx-5 -mt-5 mb-4 overflow-hidden rounded-t-[18px]">
                  <img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute top-3 left-3 bg-[var(--rs-cream)] text-[var(--rs-ink)] text-xs font-medium px-3 py-1 rounded-full">From £{s.from}</div>
                </div>
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-lg bg-[var(--rs-green)]/10 grid place-items-center text-[var(--rs-green)] shrink-0">
                    <Icon className="w-4 h-4" />
                  </div>
                  <h3 className="h-display text-lg text-[var(--rs-ink)] leading-tight">{s.title}</h3>
                </div>
                <p className="mt-3 text-sm text-[var(--rs-ink)]/70 leading-relaxed">{s.short}</p>
                <div className="mt-auto pt-4 inline-flex items-center gap-1 text-sm font-medium text-[var(--rs-coral)] group-hover:gap-2 transition-all">
                  Learn more <ArrowUpRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
